import { Grid, Table, TableHead, TableRow, TableCell, TableBody, Typography, List, ListItem } from '@mui/material';
import { LocalizationIds } from 'helpers/Localizations';
import { appUserContext } from 'helpers/services';
import { useContext } from 'react';
import { useIntl } from 'react-intl';
import Moment from 'react-moment';
import { customerTicketDetailsContext } from '../../CustomerTicketDetailsContext';


let Orders = () => {
    let { formatMessage } = useIntl();

    let { isMobile } = useContext(appUserContext);

    let { ticket } = useContext(customerTicketDetailsContext);

    return (
        <>
            {isMobile === false &&
                <Grid container>
                    <Grid item xs>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{formatMessage({ id: LocalizationIds.Order })}</TableCell>
                                    <TableCell>{formatMessage({ id: LocalizationIds.Description })}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {ticket.orders.map((order, index) =>
                                    <TableRow hover key={index}>
                                        <TableCell>
                                            <Typography variant="body2">
                                                {order.orderType}{order.orderNumber}
                                            </Typography>
                                            {order.orderDate &&
                                                <Typography variant="caption">
                                                    <Moment date={order.orderDate} format="LL" />
                                                </Typography>
                                            }
                                        </TableCell>
                                        <TableCell>{order.orderTitle}</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
            }
            {isMobile === true &&
                <List>
                    {ticket.orders.map((order, index) =>
                        <ListItem disableGutters divider key={index}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        <b>{formatMessage({ id: LocalizationIds.Order })}:</b>&nbsp;
                                    </Typography>
                                    <Typography variant="body2">
                                        {order.orderType}{order.orderNumber}
                                    </Typography>
                                    {order.orderDate &&
                                        <Typography variant="caption">
                                            <Moment date={order.orderDate} format="LL" />
                                        </Typography>
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        <b>{formatMessage({ id: LocalizationIds.Description })}:</b>&nbsp;
                                    </Typography>
                                    {order.orderTitle}
                                </Grid>
                            </Grid>
                        </ListItem>
                    )}
                </List>
            }
        </>
    )
}

export default Orders;